import React from 'react';
import { NoResultsFilter } from 'src/assets/index';
import { FormattedMessage } from 'react-intl';
import './style.scss';

interface IProps {
  onReset: () => void;
}

export class EmptyFilterMessage extends React.Component<IProps> {
  render(): React.ReactNode {
    const { onReset } = this.props;

    return (
      <div className="no-filter-msg">
        <NoResultsFilter />
        <div className="no-filter-msg__info">
          <p className="no-filter-msg__title">
            <FormattedMessage id="no.showing.filter" />
          </p>
          <p className="no-filter-msg__text">
            <FormattedMessage id="reset.filter.left" />{' '}
            <a onClick={onReset}>
              <FormattedMessage id="reset.all" />
            </a>{' '}
            <FormattedMessage id="reset.filter.right" />
          </p>
        </div>
      </div>
    );
  }
}
